import React from 'react';
import PropTypes from 'prop-types';

import styled from 'styled-components';
import media from '../../utils/mediaQueries';
import { ERROR_COLOR } from '../../theme';

const Row = styled.div`
  display: flex;
  flex-direction: ${(props) => props.isFullWidthLabel ? 'column' : 'row'};
  margin-bottom: 32px;
  
  ${media.mobile`
    flex-direction: column;
    margin-bottom: 24px;
  `}
`;

const Label = styled.div`
  font-size: 18px;
  font-weight: ${(props) => props?.theme?.fontWeight?.formFieldLabel || 600};
  line-height: 1.33;
  letter-spacing: 0.2px;
  width: ${(props) => props.isFullWidthLabel ? '100%' : '45%'};
  flex: 0 0 45%;
  margin: 6px 0 8px;
  padding-right: 24px;
  ${(props) => props.error && `color: ${ERROR_COLOR};`}
  
  ${media.mobile`
    width: 100%;
    padding-right: 0;
  `}
`;

const Field = styled.div`
  width: 100%;
`;

const LabeledField = (props) => {
  const {
    isFullWidthLabel, isRequired, label, children, error, labelAddition,
  } = props;
  return (
    <Row isFullWidthLabel={isFullWidthLabel}>
      <Label isFullWidthLabel={isFullWidthLabel} error={error}>
        {`${label}${isRequired ? '*' : ''}`}
        <div>{labelAddition}</div>
      </Label>
      <Field>
        {children}
      </Field>
    </Row>
  );
};

LabeledField.propTypes = {
  isFullWidthLabel: PropTypes.bool,
  isRequired: PropTypes.bool,
  label: PropTypes.string.isRequired,
  labelAddition: PropTypes.any,
  children: PropTypes.node.isRequired,
  error: PropTypes.bool,
};

LabeledField.defaultProps = {
  isFullWidthLabel: false,
  isRequired: false,
  error: false,
  labelAddition: null,
};

export { LabeledField };
